export default (urlParameters) => {
  return {
    detail_panel: true,
    storm_map_selector_button: true,
    storm_header_block: true,
    ui_storage_name: 'lifestyleStormMapUIStore'
  }
}